import { useHouseholdInsightsData } from '../../data/hooks/useHouseholdInsightsData';
import { parseOccupationGroup } from '../../data/parsers/parseOccupationGroup';
import { InsightsMetricList } from '../InsightsMetricList/InsightsMetricList';

export const OccupationGroup = () => {
  const { data, isLoading } = useHouseholdInsightsData(parseOccupationGroup);

  return <InsightsMetricList title="Occupation Group" unitLabel="households" items={data} isLoading={isLoading} />;
};
